import { Tag } from "antd";
import PropTypes from "prop-types";

const statusLabel = (status) => {
  switch (status) {
    case "p":
      return "Pending";
    case "b":
      return "Blocked";
    case "d":
      return "Disabled";
    case "a":
      return "Active";
    case "h":
      return "Hidden";
    default:
      return status;
  }
};

const tagColorByStatus = (status) => {
  if (status) {
    switch (status) {
      case "Draft":
      case "d":
        return "#0dcaf0";
      case "Pending":
      case "h":
        return "#ccc";
      case "Published":
      case "a":
        return "#198754";
      default:
        return "#ccc";
    }
  }
  return "#ccc";
};

const TagStatus = ({ status }) => {
  return status !== undefined ? (
    <Tag color={tagColorByStatus(status)}>{statusLabel(status)}</Tag>
  ) : null;
};

TagStatus.propTypes = {
  status: PropTypes.string,
};

export default TagStatus;
